import axiosClient from "utils/api/axios-client";

const notificationApi = {
  getAll: (params) => {
    const url = "/api/v1/notifications";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/notifications/${id}`;
    return axiosClient.get(url);
  },
  create: (notification) => {
    const url = `/api/v1/notifications/`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.post(url, notification, config);
  },
  update: (id, notification) => {
    const url = `/api/v1/notifications/${id}`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.put(url, notification, config);
  },
  delete: (id) => {
    const url = `/api/v1/notifications/${id}`;
    return axiosClient.delete(url);
  },
};

export default notificationApi;
